/*
 *   File : preview.js
 *   Author : https://evoqins.com
 *   Description : Preview modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';

// custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';

// custom style
import style from "../../Style/Component/modal.module.scss";

const PreviewModal = (props) => {

    const [showTime, setShowTime] = useState("");
    const [isBannerExpanded, setIsBannerExpanded] = useState(false);

    useEffect(() => {
        if (props.status === true) {
            _handleCloseModal();
        }
    }, [props.status]);

    useEffect(() => {

        if (props.type === 1) {
            // handle created time 
            const _formateTimeAgo = () => {
                const crated_date = props.data.created;
                const updated_created_date = new Date(crated_date);
                if (isNaN(updated_created_date)) return "";

                const now = new Date();
                const seconds = Math.floor((now - updated_created_date) / 1000);

                if (seconds < 300) {
                    return "now";
                } else if (seconds < 60) {
                    return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
                } else if (seconds < 3600) {
                    const minutes = Math.floor(seconds / 60);
                    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
                } else if (seconds < 86400) {
                    const hours = Math.floor(seconds / 3600);
                    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
                } else if (seconds < 172800) {
                    return "yesterday";
                } else {
                    const days = Math.floor(seconds / 86400);
                    return `${days} day${days > 1 ? "s" : ""} ago`;
                }
            };

            const show_time = _formateTimeAgo();
            setShowTime(show_time);
            setIsBannerExpanded(false);
        }
    }, [props.type]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("preview-modal-close");
        button.click();
        props.handleClose();
    };

    // handle send
    const _handleSend = () => {
        props.handleSend();
    };

    const _handleToggleBanner = () => {
        setIsBannerExpanded((prev) => !prev);
    };



    return (
        <div className="modal fade "
            id="preview-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="PreviewModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${props.type === 2 ? 'modal-lg' : style.e_push_notification_modal_width} modal-dialog-scrollable border-radius-28`}>
                <span id='preview-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={`${props.button === true ? "pb-0" : "pb-4 "} modal-content border-radius-28  border-0`}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top  pb-2">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.title ? props.title : 'Create push notification'}
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`${props.button !== true ? '' : 'pt-3 pb-0'} modal-body px-0`}>
                        {props.type === 1 ?
                            <>
                                <div className='padding-32px-lr'>
                                    <div className='padding-24px-all  e-bg-magnolia border-radius-16 e-border-1px-blue-violet '>
                                        <div className='d-flex align-items-center justify-content-center position-relative'>
                                            <img src={require('../../Assets/Image/Others/mobile-design.png')}
                                                alt='logo'
                                                height={460}
                                                className='w-230px ' />

                                            <div className='padding-12px-all e-bg-white border-radius-8 w-220px position-absolute top-100px'>
                                                <div className='d-flex align-items-start justify-content-between'>
                                                    <div className='d-flex pe-1'>
                                                        {props.data.image ?
                                                            <div>
                                                                <img src={props.data.image}
                                                                    className='object-fit-contain border-radius-4'
                                                                    width={28}
                                                                    height={28}
                                                                    alt="logo" />
                                                            </div>
                                                            :
                                                            <div className='e-bg-blue-violet rounded-circle padding-2px-all p-1 d-flex align-items-center justify-content-center' style={{height:"30px",width:"30px"}}>
                                                                <img src={require('../../Assets/Image/ic_stat_onesignal_default.png')}
                                                                    className='object-fit-contain border-radius-4'
                                                                    width={24}
                                                                    height={24}
                                                                    alt="logo" />
                                                            </div>
                                                        }
                                                        <div className='ps-2 align-items-start justify-content-center d-flex flex-column'>
                                                            <div className='pb-0 e-primary-font e-font-weight-600 e-font-10 line-height-12px e-text-dim-black'>
                                                                {props.data.title}
                                                            </div>
                                                            <div className='e-primary-font e-font-weight-400 e-font-6 line-height-8px e-text-dim-black truncate-four-line'>
                                                                {props.data.description ? props.data.description : ""}
                                                            </div>
                                                            <div className='e-primary-font e-font-weight-400 e-font-6 line-height-8px e-text-dim-black text-nowrap pt-1'>
                                                                {showTime}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {props.data?.banner_image &&
                                                        <div className='d-flex align-items-center justify-content-start gap-1 cursor-pointer'
                                                            onClick={_handleToggleBanner}>
                                                            <img src={props.data.banner_image}
                                                                className={`${isBannerExpanded ? "invisible" : ""} object-fit-cover border-radius-4`}
                                                                width={24}
                                                                height={24}
                                                                alt="banner image" />


                                                            <Icon icon="dropdown"
                                                                className={`d-flex ${isBannerExpanded ? 'e-rotate-180' : ''}`}
                                                                size={10}
                                                                color={"#000000"}

                                                            />
                                                        </div>
                                                    }
                                                </div>

                                                {props.data?.banner_image && isBannerExpanded &&
                                                    <div className='pt-1'>
                                                        <img src={props.data.banner_image}
                                                            className='w-100 h-100 object-fit-contain border-radius-4'
                                                            height={56}
                                                            alt="banner image" />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <div className='padding-32px-lr padding-32px-top text-center padding-62px-bottom p'>
                                {/* <img src={props.data ? props.data : require('../../Assets/Image/Others/monthly-report.png')}
                                    draggable={false}
                                    width={414}
                                    className='object-fit-contain'
                                    height={254}
                                    alt='document' /> */}

                                {(() => {
                                    const fileUrl = props.data ? props.data : require('../../Assets/Image/Others/monthly-report.png');
                                    const isPDF = typeof fileUrl === 'string' && (
                                        fileUrl.toLowerCase().includes('.pdf') ||
                                        fileUrl.split('?')[0].toLowerCase().endsWith('.pdf')
                                    );

                                    return isPDF ? (
                                        <iframe
                                            src={fileUrl}
                                            width={514}
                                            height={250}
                                            className='object-fit-contain w-100'
                                            title='file preview'
                                        />
                                    ) : (
                                        <img
                                            src={fileUrl}
                                            draggable={false}
                                            width={414}
                                            height={254}
                                            className='object-fit-contain'
                                            alt='file preview'
                                        />
                                    );
                                })()}
                            </div>
                        }
                    </div>

                    {/* Modal footer  */}
                    {props.button === true &&
                        <div className={`padding-32px-all py-4 modal-footer border-0 gap-3`}>
                            <>
                                <SecondaryButton name="Cancel"
                                    paddingBlock='padding-12px-tb padding-52px-lr'
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name="Send"
                                    paddingBlock='padding-12px-tb padding-52px-lr'
                                    onClick={_handleSend} />
                            </>
                        </div>
                    }
                </div>
            </div>
        </div >
    )
}

export default PreviewModal;

PreviewModal.defaultProps = {
    handleClose: () => { },
    type: 1,
}